<template>
	<div>
		<h4>Sliders</h4>
		<vs-alert class="my-2" :active="sliders.length===0">
			Nog geen sliders toegevoegd
		</vs-alert>
			<vs-collapse type="margin" class="p-0">
				<draggable v-model="sliders" >
				<vs-collapse-item class="faq-bg rounded-lg item"  v-for="(slider, index) in sliders" :key="index" :open="slider.open">
					<div slot="header">
						<vs-list-item :title="slider.title">
							<vs-button @click="deleteSlider(index)" @click.stop class="mr-5" color="danger" type="filled" icon-pack="feather" icon="icon-delete"></vs-button>
						</vs-list-item>
					</div>
					<vs-input class="w-full" label="Titel" v-model="slider.title"></vs-input>
					<vs-textarea label="Content" v-model="slider.text" class="mt-2"></vs-textarea>
					<vs-input class="w-full" label="Knop tekst" v-model="slider.action"></vs-input>
					<vs-input class="w-full" label="link" v-model="slider.href"></vs-input>
					<div v-if="slider.image">
					<vs-images hover="blur">
						<vs-image :src="slider.image"></vs-image>
					</vs-images>
					<vs-button @click="slider.image = null">Andere afbeelding</vs-button>
					</div>
					<vs-upload v-else  class="mt-2" automatic limit="1" :action="imageUploadUrl" :headers="uploadHeaders" @on-success="successUpload($event, slider)" @on-delete="slider.image = null" />
				</vs-collapse-item>
				</draggable>
			</vs-collapse>
			<vs-button slot="footer" @click="addSlider">Voeg slider toe</vs-button>
		<vs-button :disabled="loading" @click="saveSliders()" color="success" class="mt-2">Sliders opslaan</vs-button>
		<h4 class="mt-5">Blokken</h4>
		<vs-collapse type="margin" class="p-0 item">
			<draggable v-model="blocks" >
			<vs-collapse-item class="faq-bg rounded-lg"  v-for="(block, index) in blocks" :key="index">
				<div slot="header">
					<vs-list-item :title="block.title"></vs-list-item>
				</div>
				<vs-input class="w-full" label="Titel" v-model="block.title"></vs-input>
				<vs-input class="w-full" label="Url" v-model="block.href"></vs-input>
				<div v-if="block.image">
					<vs-images hover="blur">
						<vs-image :src="block.image"></vs-image>
					</vs-images>
					<vs-button @click="block.image = null">Andere afbeelding</vs-button>
				</div>
				<vs-upload v-else  class="mt-2" automatic limit="1" :action="imageUploadUrl" :headers="uploadHeaders" @on-success="successUpload($event, block)" @on-delete="block.image = null" />
			</vs-collapse-item>
			</draggable>
		</vs-collapse>
		<vs-button :disabled="loading" @click="saveBlocks()" color="success" class="mt-2">Blokken opslaan</vs-button>

	</div>
</template>
<script>
	import draggable from 'vuedraggable'
	import {baseUrl} from '../../api';
	import {mapState} from "vuex";
	import api from '../../api';

	export default {
		name: 'Home',
		components: {
			draggable
		},
		props: {},
		data () {
			return {
				sliders: [],
				blocks: [],
				imageUploadUrl: baseUrl + 'admin/image-upload',
				loading: false
			}
		},
		computed: {
			...mapState({
				authToken: state=>state.auth.token
			}),
			uploadHeaders(){
				return {
					Authorization: 'Bearer ' + this.authToken
				}
			}
		},
		mounted () {
			this.getData();
		},
		methods: {
			addSlider(){
				this.sliders.push({
					title: "",
					open: true
				})
			},
			deleteSlider(index){
				console.log(index);
				this.sliders.splice(index, 1);
			},
			successUpload(e, slider){
				let response = JSON.parse(e.target.responseText);
				slider.image = response.path;
			},
			getData(){
				api.post("admin/settings", {keys: ['sliders', 'blocks']}).then(response=>{
					console.log(response);
					this.blocks = response.data.find(setting=>setting.key==='blocks').value;
					let sliders = response.data.find(setting=>setting.key==='sliders').value;
					if(sliders === null){
						sliders = [];
					}
					this.sliders = sliders.map((slider)=>{
						slider.open = false;
						return slider;
					});
				}).catch((error)=>{
					console.log(error);
				})
			},
			saveSliders(){
				api.put("admin/settings", {settings: {'sliders': this.sliders}}).then(()=>{
					this.$vs.dialog({
						title: 'Gelukt!',
						text: 'Opslaan van de sliders is gelukt',
						color: 'success'
					})
				}).catch((error)=>{
					console.log(error);
				})
			},
			saveBlocks(){
				api.put("admin/settings", {settings: {'blocks': this.blocks}}).then(()=>{
					this.$vs.dialog({
						title: 'Gelukt!',
						text: 'Opslaan van de sliders is gelukt',
						color: 'success'
					})
				}).catch((error)=>{
					console.log(error);
				})
			},
		}
	}

</script>
